export default __webpack_public_path__ + "static/media/PLANET4_logo_PLANETA_BLACK.bb1421c4.png";